import { twMerge } from "tailwind-merge";

interface AspectRatioProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: number;
  height?: number;
}

const AspectRatio = ({ width = 16, height = 9, style, className, ...rest }: AspectRatioProps) => {
  return (
    <div
      className={twMerge(["relative block aspect-[var(--aspect-ratio)] w-full *:size-full *:object-cover", className])}
      style={
        {
          ...style,
          "--aspect-ratio": `${width} / ${height}`,
        } as React.CSSProperties
      }
      {...rest}
    />
  );
};

export default AspectRatio;
